import { Text } from '@sitecore-jss/sitecore-jss-react';
import React, { FC, useEffect, useRef, useState } from 'react';
import { iconSize } from '../../../../../constants/icon.constants';
import { googleSocialEvent } from '../../../../../utils/analytics';
import { documentService, windowService } from '../../../../../utils/window.utils';
import Icon from '../../../icon';
import RoutableNotEditableLink from '../../../routableNotEditableLink';
import { TSocialLink, TSocialMediaDropdownProps } from '../../types/socialMediaBar.types';

const SocialMediaDropdown: FC<TSocialMediaDropdownProps> = (props) => {
    const { isEEactive, socialLinksItems, useAnalytics, socialText, shareURL } = props;
    const [shouldShowDropdownList, setShouldShowDropdownList] = useState(false);
    const dropdownElmRef = useRef<HTMLButtonElement>(null);

    const handleClickOutside = (e) => {
        if (dropdownElmRef?.current?.contains(e?.target)) return;
        setShouldShowDropdownList(false);
    };

    useEffect(() => {
        const doc = documentService() as Document;
        doc.addEventListener('click', handleClickOutside, false);

        return () => doc.removeEventListener('click', handleClickOutside, false);
    }, [socialLinksItems]);

    useEffect(() => {
        if (shouldShowDropdownList) windowService()?.a2a?.init_all?.();
    }, [shouldShowDropdownList])

    return (
        <div className={'social-media-dropdown'}>
            <button
                className={'social-media-dropdown__button'}
                onClick={() => setShouldShowDropdownList(!shouldShowDropdownList)}
                ref={dropdownElmRef}
            >
                {socialText && <Text tag="p" className="social-media-dropdown__title" field={socialText} />}
                <Icon iconName={'social-sharing-share'} size={iconSize.dsk} color={'primary'} extraClassName={'social-media-dropdown__button-icon'} />
            </button>
            {shouldShowDropdownList && (
                <ul className="social-media-dropdown__options a2a_kit a2a_kit_size_32 a2a_default_style" data-a2a-url={shareURL}>
                    {socialLinksItems
                        ?.filter((item) => !!(isEEactive || (item?.fields?.icon?.fields?.iconKey?.value && item?.fields?.icon?.fields?.iconUrl?.value)))
                        ?.map((item: TSocialLink) => {
                            return (
                                <li key={item?.id} className="social-media-dropdown__option">
                                    <RoutableNotEditableLink
                                        href={''}
                                        className={`social-media-dropdown__option-link a2a_button_${item?.fields?.socialMedia?.displayName?.toLowerCase()}`}
                                        target="_blank"
                                        data-title={item.fields?.postText?.value}
                                        data-usefallback-window-title={true}
                                        onClick={() => !isEEactive && useAnalytics && googleSocialEvent(item?.fields?.socialMedia?.displayName)}
                                    >
                                        <p className="social-media-dropdown__option-title">
                                            {item?.fields?.socialMedia?.displayName}
                                        </p>
                                        <Icon iconField={item?.fields?.icon} size={iconSize.dsk} color={'primary'} extraClassName={'social-media-dropdown__option-icon'} />
                                    </RoutableNotEditableLink>
                                </li>
                            );
                        })}
                </ul>
            )}
        </div>
    );
};

export default SocialMediaDropdown;
